// extracted by mini-css-extract-plugin
export var navArtworksList = "navigation-module--nav-artworks-list--d69d7";
export var navContributorsList = "navigation-module--nav-contributors-list--4f0d5";